<nav class="app-navigation">
  <ul class="app-navigation__list">
    @for (item of navItems(); track item.path) {
      <li class="app-navigation__item">
        <a
          [routerLink]="item.path"
          routerLinkActive="app-navigation__link--active"
          class="app-navigation__link"
        >
          {{ item.label }}
        </a>
      </li>
    }
  </ul>
</nav>
